const stopNestedSubmissionBubbling = (handler: any) => {
  return (
    (e: any) => {
      e.stopPropagation()
      handler(e)
    }
  )
}

export default stopNestedSubmissionBubbling



// WEBPACK FOOTER //
// ./src/utils/stop-nested-submission-bubbling.ts